import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

// Backend
export const ERROR_SOMETHING_WENT_WRONG = "something_went_wrong";
export const ERROR_AUTHENTICATION_FAILED = "invalid_account";

export default formWithMessages(props => {
  const { onLogin, disabled } = props;
  return (
    <Form
      formProps={{
        id: `login-form`,
        horizontal: true,
      }}
      onSubmit={onLogin}
      {...props.messagesProps}
      fields={{
        username: {
          uiProps: {
            type: "text",
            placeholder: "Enter your username",
            autoFocus: true,
            maxLength: 128,
          },
          position: 1,
          initialValue: "",
          label: "Username",
        },
        password: {
          uiProps: {
            type: "password",
            placeholder: "Enter your password",
            maxLength: 128,
          },
          position: 2,
          initialValue: "",
          label: "Password",
        },
      }}
      validation={formData => undefined}
      submitButtonProps={{
        disabled,
        children: "LOGIN",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_SOMETHING_WENT_WRONG]: "Something went wrong",
        [ERROR_AUTHENTICATION_FAILED]:
          "Invalid username or password, please try again!",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/LoginForm.js